import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TypedMemo } from '../../../common/types';
import { platformMeta } from '../platformMeta';
import { SocialPlatform } from '../types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

const TILE_CLASS: Record<SocialPlatform, string | undefined> = {
  tiktok: styles.pfTiktok,
  instagram: styles.pfInstagram,
  youtube: styles.pfYoutube,
  facebook: styles.pfFacebook,
  threads: styles.pfThreads,
  x: styles.pfX,
};

interface PlatformTileProps {
  platform: SocialPlatform;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * The platform as a small tile with its brand mark (design a1). The brand mark, not a colour bar:
 * TikTok and Threads are both near black. The name is in the card text, so the tile is decoration.
 */
const PlatformTileComponent: React.FC<PlatformTileProps> = ({ platform, size = 'sm', className }) => (
  <span
    className={clsx(styles.pf, TILE_CLASS[platform], size === 'md' && styles.pfMd, className)}
    aria-hidden="true"
    title={platformMeta[platform].name}
  >
    <FontAwesomeIcon icon={platformMeta[platform].icon} />
  </span>
);

export const PlatformTile = TypedMemo(PlatformTileComponent);
